module.exports = __webpack_public_path__ + "img/a_comer_club.05cb8909.svg";